import request from './request';

export function getTagsConfiguration() {
  return request({
    path: `/v1/tags/configuration`,
  });
}

export function updateTagsConfiguration(configuration) {
  return request({
    path: `/v1/tags/configuration`,
    type: 'post',
    json: { configuration },
  });
}
